var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashbin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9950_143522",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9950_143522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "delete_2",
    d: "M5.07696 13.3334C4.77867 13.3334 4.52461 13.2285 4.31477 13.0187C4.10495 12.8088 4.00004 12.5548 4.00004 12.2565V4.00006H3.33337V3.33339H6.00004V2.82056H10V3.33339H12.6667V4.00006H12V12.2565C12 12.5633 11.8973 12.8195 11.6917 13.0251C11.4862 13.2306 11.23 13.3334 10.9231 13.3334H5.07696ZM11.3334 4.00006H4.66671V12.2565C4.66671 12.3761 4.70517 12.4744 4.78209 12.5513C4.85901 12.6283 4.9573 12.6667 5.07696 12.6667H10.9231C11.0257 12.6667 11.1197 12.624 11.2052 12.5385C11.2906 12.453 11.3334 12.359 11.3334 12.2565V4.00006ZM6.53849 11.3334H7.20517V5.33339H6.53849V11.3334ZM8.79491 11.3334H9.46159V5.33339H8.79491V11.3334Z",
    fill: "#595959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashbin);
export default __webpack_public_path__ + "static/media/trashbin.42d1fe18fafe4c58e09e60d346ef7cee.svg";
export { ForwardRef as ReactComponent };